// src/core/components/infiniteAutocomplete.tsx
import { UIEvent } from "react"
import { ListboxComponent } from "./listBoxComponent"

export interface InfiniteListboxProps {
  hasMore: boolean
  isFetching: boolean
  onLoadMore: () => void
  /** Порог до дна скролла, px (default 48). */
  threshold?: number
}

/**
 * Пропсы для MUI Autocomplete: виртуализированный listbox (core ListboxComponent,
 * react-window) + догрузка следующей страницы по скроллу. Существующий
 * ListboxComponent прокидывает посторонние пропсы (в т.ч. onScroll) на
 * outer-элемент react-window через context, поэтому ListboxProps.onScroll доезжает.
 */
export function infiniteListboxProps({
  hasMore,
  isFetching,
  onLoadMore,
  threshold = 48,
}: InfiniteListboxProps) {
  // HTMLElement (не div/ul): MUI Autocomplete ожидает UIEventHandler<HTMLUListElement>,
  // а react-window outer может быть div — событие совместимо в обе стороны.
  const onScroll = (e: UIEvent<HTMLElement>) => {
    if (!hasMore || isFetching) return
    const el = e.currentTarget
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= threshold) {
      onLoadMore()
    }
  }
  return {
    loading: isFetching,
    loadingText: (
      <span role="status" onMouseDown={(event) => event.preventDefault()}>
        Загрузка…
      </span>
    ),
    ListboxComponent,
    ListboxProps: { onScroll, isLoading: isFetching },
  }
}
